'use client'

import { useState } from 'react'
import { Button, Dialog, Navigation, Divider, Text, Container, Icon, Spacer } from '@vinted/web-ui'
import { InfoCircle16, Redirect16, X24 } from '@vinted/monochrome-icons'

import { useTranslate } from '@marketplace-web/shared/i18n'

import AdInfo from '../AdInfo'

// Todo: this is dummy html, replace with real one later
const SAMPLE_HTML = `
<!DOCTYPE html>
<html>
  <head>
    <title>Target All 1</title>
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <style>
      html, body {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      img {
        max-width: 100%;
        max-height: 100%;
        display: block;
      }
      a, img {
        border-radius: inherit;
      }
    </style>
  </head>
  <body>
    <a href="https://target.link.com" target="_top">
      <img src="https://inflcm.com/images/DisneyPlus_300x250_4.jpg" alt="" />
    </a>
  </body>
</html>
`
const height = 250
const width = 300

const VanOfferAdvertisement = () => {
  const [isOpen, setIsOpen] = useState(true)

  const translate = useTranslate('vinted_ads_network.ad_offer')

  const onClose = () => setIsOpen(false)

  return (
    <Dialog show={isOpen}>
      <Navigation
        body={translate('header_title')}
        right={
          <Button
            inline
            iconName={X24}
            styling={Button.Styling.Flat}
            testId="van-offer-slot-modal-close"
            aria={{ 'aria-label': translate('a11y.actions.close') }}
            onClick={onClose}
          />
        }
      />
      <Divider />
      <Container>
        <div className="van-offer-container">
          <div data-testid="van-offer-slot" id="van-offer-slot">
            <iframe
              title="van-offer-iframe"
              width={width}
              height={height}
              className="van-offer-iframe"
              srcDoc={SAMPLE_HTML}
            />
          </div>
          <Spacer size={Spacer.Size.Regular} />
          <Text
            as="h2"
            type={Text.Type.SectionHeading}
            text={translate('title')}
            alignment={Text.Alignment.Center}
            width={Text.Width.Parent}
          />
          <Text
            as="p"
            text={translate('subtitle')}
            type={Text.Type.Subtitle}
            alignment={Text.Alignment.Center}
            width={Text.Width.Parent}
          />
          <Spacer size={Spacer.Size.Medium} />
          <Button
            text={translate('button')}
            aria={{ 'aria-label': translate('a11y.actions.claim_offer') }}
            iconPosition={Button.IconPosition.Right}
            iconName={Redirect16}
            styling={Button.Styling.Filled}
            size={Button.Size.Medium}
            theme="primary"
            onClick={onClose}
            testId="van-offer-slot-close-button"
          />
        </div>
      </Container>
      <Container>
        <div className="van-offer-info-container">
          <div className="van-offer-info">
            <AdInfo />
            <Icon name={InfoCircle16} />
          </div>
          <a href="/">
            <Text
              as="p"
              type={Text.Type.Caption}
              theme="muted"
              text={translate('privacy_policy')}
              underline
            />
          </a>
        </div>
      </Container>
    </Dialog>
  )
}

export default VanOfferAdvertisement
